// @flow
import {
    closePost,
    editPost,
    newPost,
    submitPost,
    submitPostFailure,
    submitPostSuccess,
    updatePost
} from "../actions/post.actions";
import { handleActions } from "redux-actions";
import Record from "../flow/Record";
import { Post } from "../records/post.record";
import { updateUserSettings } from "../actions/login.actions";
import { RequestState } from "../records/request.record";
import { setupRequest } from "./request.reducer";
import { saveProfileSuccess } from "../actions/editProfile.actions";

const createRequest = setupRequest("createRequest");

class CreateEditPost extends Record({
    createRequest: new RequestState(),
    post: new Post(),
    submitSuccess: false,
    defaultLanguage: "en",
    open: false
}) {
    createRequest: RequestState;
    post: Post;
    submitSuccess: boolean;
    defaultLanguage: string;
    open: boolean;
}

function updateLanguage(state, languages) {
    let language;
    languages.forEach(l => {
        if (l.isLearning) {
            language = l.language;
        }
    });
    language = language || "en";
    return state.merge({
        post: state.post.set("language", language),
        defaultLanguage: language
    });
}

const createEditPost = handleActions(
    {
        [submitPost]: createRequest.start,
        [submitPostSuccess](state, { payload: { post } }) {
            state = createRequest.success(state);
            state = state.merge({
                submitSuccess: true,
                post: post
            });
            return state;
        },
        [submitPostFailure]: createRequest.failure,
        [newPost](state) {
            return state.merge({
                post: new Post({
                    language: state.defaultLanguage
                }),
                submitSuccess: false,
                open: true
            });
        },
        [editPost](state, { payload: { post } }) {
            return state.merge({
                post: post,
                submitSuccess: false,
                open: true
            });
        },
        [closePost](state) {
            return state.set("open", false);
        },
        [updatePost](state, { payload }) {
            return state.set("post", state.post.merge(payload));
        },
        [saveProfileSuccess](state, { payload: { languages } }) {
            return updateLanguage(state, languages);
        },
        [updateUserSettings](state, { payload: { user: { languages } } }) {
            return updateLanguage(state, languages);
        }
    },
    new CreateEditPost()
);

export default createEditPost;



// WEBPACK FOOTER //
// ./src/reducers/createEditPost.reducer.js